import React from 'react'
import { IconProps } from './icons.models'

export const RightIcon: React.FC<IconProps> = ({
    width = 15,
    height = 15,
    fillColor = '#00A634',
    className,
    onClick,
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.08333 0C3.1875 0 0 3.1875 0 7.08333C0 10.9792 3.1875 14.1667 7.08333 14.1667C10.9792 14.1667 14.1667 10.9792 14.1667 7.08333C14.1667 3.1875 10.9792 0 7.08333 0ZM7.08333 12.75C3.95958 12.75 1.41667 10.2071 1.41667 7.08333C1.41667 3.95958 3.95958 1.41667 7.08333 1.41667C10.2071 1.41667 12.75 3.95958 12.75 7.08333C12.75 10.2071 10.2071 12.75 7.08333 12.75ZM10.3346 3.9525L5.66667 8.62042L3.83208 6.79292L2.83333 7.79167L5.66667 10.625L11.3333 4.95833L10.3346 3.9525Z" fill={fillColor} />
        </svg>
    )
}
